// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultNotLogged_wrapper__8IETg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/DefaultNotLogged.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `DefaultNotLogged_wrapper__8IETg`
};
export default ___CSS_LOADER_EXPORT___;
